import AppLayout from '@/common/layouts/AppLayout.vue'
import AuthLayout from '@/common/layouts/AuthLayout.vue'
// import RouteViewComponent from '@/common/layouts/RouterBypass.vue'
import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'user',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/DashboardEmployee.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      // {
      //   name: 'payments',
      //   path: '/payments',
      //   component: RouteViewComponent,
      //   children: [
      //     {
      //       name: 'payment-methods',
      //       path: 'payment-methods',
      //       component: () => import('../pages/payments/PaymentsPage.vue'),
      //     },
      //     {
      //       name: 'billing',
      //       path: 'billing',
      //       component: () => import('../pages/billing/BillingPage.vue'),
      //     },
      //     {
      //       name: 'pricing-plans',
      //       path: 'pricing-plans',
      //       component: () => import('../pages/pricing-plans/PricingPlans.vue'),
      //     },
      //   ],
      // },
      // {
      //   name: 'faq',
      //   path: '/faq',
      //   component: () => import('../pages/faq/FaqPage.vue'),
      // },
    ],
  },
  {
    name: 'tenant-admin',
    path: '/tenant-admin',
    component: AppLayout,
    children: [
      {
        name: 'tenant-settings',
        path: 'tenant-settings',
        component: () => import('../pages/tenant-admin/TenantSettings.vue'),
      },
      {
        name: 'manage-companies',
        path: 'manage-companies',
        component: () => import('../pages/project-management/ManageCompanies.vue'),
        meta: { requiredPermission: 'Page.Company' },
      },
      {
        name: 'tenant-roles',
        path: 'tenant-roles',
        component: () => import('../pages/tenant-admin/TenantRoles.vue'),
        meta: { requiredPermission: 'Page.Role' },
      },
      {
        name: 'organizational-hierarchy',
        path: 'organizational-hierarchy',
        component: () => import('../pages/tenant-admin/OrganizationalHierarchy.vue'),
        meta: { requiredPermission: 'Page.OrganizationHierarchy' },
      },
      // {
      //   name: 'OrganizationHierarchy',
      //   path: '/tenant-admin/organizational-hierarchy/:id?',
      //   component: () => import('../pages/tenant-admin/OrganizationalHierarchy.vue'),
      //   meta: { requiredPermission: 'Page.OrganizationHierarchy' },
      // },
      {
        name: 'tenant-employees',
        path: 'tenant-employees',
        component: () => import('../pages/tenant-admin/TenantEmployees.vue'),
        meta: { requiredPermission: 'Page.Employee' },
      },
      {
        name: 'organization-employees',
        path: 'organization-employees',
        component: () => import('../pages/tenant-admin/OrganizationEmployee.vue'),
        meta: { requiredPermission: 'Page.OrganizationEmployee' },
      },
      {
        name: 'assignable-roles',
        path: 'assignable-roles',
        component: () => import('../pages/tenant-admin/AssignableRoles.vue'),
        meta: { requiredPermission: 'Page.AssignableRole' },
      },
      {
        name: 'role-access',
        path: 'role-access',
        component: () => import('../pages/tenant-admin/RoleAccess.vue'),
        meta: { requiredPermission: 'Page.RoleAccess' },
      },
      {
        name: 'role-assignments',
        path: 'role-assignments',
        component: () => import('../pages/tenant-admin/RoleAssignments.vue'),
        meta: { requiredPermission: 'Page.RoleAssignment' },
      },
      {
        name: 'code-types',
        path: 'code-types',
        component: () => import('../pages/tenant-admin/CodeType.vue'),
        meta: { requiredPermission: 'Page.CodeType' },
      },
      {
        name: 'i18n-keys',
        path: 'i18n-keys',
        component: () => import('../pages/tenant-admin/I18nKey.vue'),
        meta: { requiredPermission: 'Page.I18nKey' },
      },
      {
        name: 'i18n-translations',
        path: 'i18n-translations',
        component: () => import('../pages/tenant-admin/I18nTranslation.vue'),
        meta: { requiredPermission: 'Page.I18nTranslation' },
      },
      {
        name: 'notification-templates',
        path: 'notification-templates',
        component: () => import('../pages/tenant-admin/NotificationTemplate.vue'),
        meta: { requiredPermission: 'Page.NotificationTemplate' },
      },
      {
        name: 'ticket-status-notification-rules',
        path: 'ticket-status-notification-rules',
        component: () => import('../pages/tenant-admin/TicketStatusNotificationRule.vue'),
        meta: { requiredPermission: 'Page.TicketStatusNotificationRule' },
      },
      {
        name: 'sequence-numbers',
        path: 'sequence-numbers',
        component: () => import('../pages/tenant-admin/SequenceNo.vue'),
        meta: { requiredPermission: 'Page.SequenceNo' },
      },
      {
        name: 'access-resources',
        path: 'access-resources',
        component: () => import('../pages/admin/AccessResources.vue'),
        meta: { requiredPermission: 'Page.AccessResource' },
      },
    ],
  },
  {
    name: 'project-management',
    path: '/project-management',
    component: AppLayout,
    children: [
      {
        name: 'company-contacts',
        path: 'company-contacts',
        component: () => import('../pages/project-management/CompanyContacts.vue'),
        meta: { requiredPermission: 'Page.CompanyContact' },
      },
      {
        name: 'manage-projects',
        path: 'manage-projects',
        component: () => import('../pages/project-management/ProjectsOverview.vue'),
        meta: { requiredPermission: 'Page.Project' },
      },
      {
        name: 'manage-contracts',
        path: 'manage-contracts',
        component: () => import('../pages/project-management/ProjectContracts.vue'),
        meta: { requiredPermission: 'Page.ProjectContract' },
      },
      {
        name: 'manage-tasks',
        path: 'manage-tasks',
        component: () => import('../pages/project-management/ProjectTasks.vue'),
        meta: { requiredPermission: 'Page.ProjectTask' },
      },
      {
        name: 'project-documents',
        path: 'project-documents',
        component: () => import('../pages/project-management/ProjectDocuments.vue'),
        meta: { requiredPermission: 'Page.ProjectDocument' },
      },
    ],
  },
  {
    name: 'ticket-management',
    path: '/ticket-management',
    component: AppLayout,
    children: [
      {
        name: 'manage-tickets',
        path: 'manage-tickets',
        component: () => import('../pages/ticket-management/ManageTickets.vue'),
        meta: { requiredPermission: 'Page.Ticket' },
      },
      {
        name: 'shopping-list',
        path: 'shopping-list',
        component: () => import('../pages/ticket-management/ShoppingList.vue'),
        meta: { requiredPermission: 'Page.ShoppingList' },
      },
      {
        name: 'manage-time-logs',
        path: 'manage-time-logs',
        component: () => import('../pages/ticket-management/TimeLogs.vue'),
        meta: { requiredPermission: 'Page.TimeLog' },
      },
      {
        name: 'manage-invoices',
        path: 'manage-invoices',
        component: () => import('../pages/ticket-management/TicketInvoices.vue'),
        meta: { requiredPermission: 'Page.Invoice' },
      },
      {
        name: 'invoice-queue',
        path: 'invoice-queue',
        component: () => import('../pages/ticket-management/InvoiceQueue.vue'),
        meta: { requiredPermission: 'Page.InvoiceQueue' },
      },
      {
        name: 'time-sheets',
        path: 'time-sheets',
        component: () => import('../pages/ticket-management/TimeSheets.vue'),
        meta: { requiredPermission: 'Page.TimeSheet' },
      },
      {
        name: 'timesheet-reports',
        path: 'timesheet-reports',
        component: () => import('../pages/ticket-management/TimesheetReport.vue'),
        meta: { requiredPermission: 'Page.TimesheetReport' },
      },
      {
        name: 'ticket-documents',
        path: 'ticket-documents',
        component: () => import('../pages/ticket-management/TicketDocuments.vue'),
        meta: { requiredPermission: 'Page.TicketDocument' },
      },
    ],
  },
  {
    name: 'product-management',
    path: '/product-management',
    component: AppLayout,
    children: [
      {
        name: 'manage-products',
        path: 'manage-products',
        component: () => import('../pages/product-management/ManageProducts.vue'),
        meta: { requiredPermission: 'Page.Product' },
      },
      {
        name: 'release-tracking',
        path: 'release-tracking',
        component: () => import('../pages/product-management/ReleaseTracking.vue'),
        meta: { requiredPermission: 'Page.Release' },
      },
      {
        name: 'license-tracking',
        path: 'license-tracking',
        component: () => import('../pages/product-management/LicenseTracking.vue'),
        meta: { requiredPermission: 'Page.License' },
      },
      {
        name: 'deployment-tracking',
        path: 'deployment-tracking',
        component: () => import('../pages/product-management/DeploymentTracking.vue'),
        meta: { requiredPermission: 'Page.Deployment' },
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      // {
      //   name: 'signup',
      //   path: 'signup',
      //   component: () => import('../pages/auth/Signup.vue'),
      // },
      {
        name: 'reset-password',
        path: 'reset-password',
        component: () => import('../pages/auth/ResetPassword.vue'),
      },
      {
        name: 'reset-password-email',
        path: 'reset-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

export default routes
